import { render, staticRenderFns } from "./digital-certificate-jump.vue?vue&type=template&id=606ec358&scoped=true&"
import script from "./digital-certificate-jump.vue?vue&type=script&lang=js&"
export * from "./digital-certificate-jump.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606ec358",
  null
  
)

export default component.exports